import React, { useEffect, useState } from "react"
import isEmail from "validator/lib/isEmail"

const moveEmailToTop = emailRef => {
  if (!emailRef || !emailRef.current) return
  // Find closest .mfn-block parent
  let block = emailRef.current.closest(".mfn-block")
  if (!block) return
  // Find .mfn-subscribe ancestor
  let subscribe = block.closest(".mfn-subscribe")
  if (!subscribe) return
  // Find .mfn-info block inside .mfn-subscribe
  let info = subscribe.querySelector(".mfn-info")
  if (!info) return
  // Move block after info
  if (info.nextSibling) {
    subscribe.insertBefore(block, info.nextSibling)
  } else {
    subscribe.appendChild(block)
  }
}

export const MFNSubscribe = () => {
  const emailRef = React.useRef(null)
  const submitRef = React.useRef(null)
  const [email, setEmail] = useState("")
  const [classes, setClasses] = useState("")

  useEffect(() => {
    const localClasses = {
      hidden: !isEmail(email),
    }
    setClasses(
      Object.keys(localClasses)
        .filter(key => localClasses[key])
        .join(" ")
    )
  }, [email])

  useEffect(() => {
    const emailCheck = e => {
      setEmail(e?.target.value.trim())
    }

    ;(function(widgets) {
      var url = "https://widget.datablocks.se/api/rose"
      if (!window._MF) {
        var b = document.createElement("script")
        b.type = "text/javascript"
        b.async = true
        b.src = url + "/assets/js/loader-v3.js"
        document.getElementsByTagName("body")[0].appendChild(b)
      }
      window._MF = window._MF || {
        data: [],
        url: url,
        ready: !!0,
        render: function() {
          window._MF.ready = !0
        },
        push: function(w) {
          window._MF.data.push(w)
        },
      }
      window._MF.push(widgets)
    })([
      {
        query: "#subscribe-module",
        widget: "subscribe-v2",
        locale: "en",
        token: "f1ca22b3-626c-4582-84d2-4ff51ae38946",
      },
    ])

    const setupRef = async () => {
      let emailInput = document.querySelector("input.mfn-field-address")
      while (!emailInput) {
        await new Promise(resolve => setTimeout(resolve, 100))
        emailInput = document.querySelector("input.mfn-field-address")
      }
      emailRef.current = emailInput
      emailRef.current.addEventListener("keyup", emailCheck)

      submitRef.current = document.querySelector(".mfn-submit")

      moveEmailToTop(emailRef)
    }
    setupRef()

    return () => {
      if (emailRef.current) {
        emailRef.current.removeEventListener("keyup", emailCheck)
      }
      emailRef.current = null
    }
  }, [])

  useEffect(() => {
    // Hide .mfn-block if a sibling .mfn-status contains .mfn-sub-success (not .mfn-hidden)
    const hideBlockOnSuccess = () => {
      const hasSuccess = document.querySelector(
        ".mfn-status .mfn-sub-success:not(.mfn-hidden)"
      )
      if (hasSuccess) {
        const blocks = document.querySelectorAll(".mfn-block:not(.mfn-status)")
        blocks.forEach(block => {
          block.style.display = "none"
        })
      }
    }
    // Run on mount and whenever DOM changes (e.g., after subscribe)
    const observer = new MutationObserver(hideBlockOnSuccess)
    const sModule = document.getElementById("subscribe-module")
    observer.observe(sModule, {
      attributes: true,
      childList: true,
      subtree: true,
    })
    hideBlockOnSuccess()
    return () => observer.disconnect()
  }, [])

  return (
    <>
      <style>
        {`
        #subscribe-module {
            position: relative;
        }
        .hidden .mfn-info-options {
            display: none;
        }
        .hidden .mfn-options {
            display: none;
        }
        .hidden .mfn-info-languages {
            display: none;
        }
        .hidden .mfn-languages {
            display: none;
        }
        .hidden .mfn-policy {
            display: none;
        }
        .hidden .mfn-submit {
            opacity: 0;
            visibility: hidden;
        }
        .mfn-subscribe ul {
            list-style: none;
        }
        .mfn-field-input:focus {
            outline: none;
        }
        .mfn-info-main {
            color: rgb(13, 13, 13);
            width: 100%;
            font-size: 24px;
            font-style: normal;
            font-weight: 700;
            line-height: 30px;
        }
        .mfn-info-options, .mfn-info-languages, .mfn-policy {
            color: rgba(13, 13, 13, 0.6);
            font-size: 16px;
            font-style: normal;
            font-weight: 200;
            line-height: 18px;
        }
        .mfn-list {
            height: auto;
            flex-wrap: wrap;
            -webkit-box-pack: justify;
            justify-content: space-between;
            width: 100%;
            margin: 5px 0px 0px;
            animation: 0.5s ease-in-out 0s 1 normal none running hMEvnl;
            opacity: 1;
            display: flex;
        }
        .mfn-list-item {
            height: 20px;
            width: calc(50% - 8px);
            margin-bottom: 10px;
            box-sizing: border-box;
            display: flex;
            -webkit-box-align: center;
            align-items: center;
        }
        .mfn-list-item label, .mfn-policy label {
            font-family: "Object Sans", sans-serif;
            -webkit-font-smoothing: antialiased;
            color: rgb(0, 0, 0);
        }
        .mfn-list-item input, .mfn-policy input {
            margin-right: 8px;
            width: auto;
            height: auto;
            border-top: none;
            border-right: none;
            border-left: none;
            border-image: initial;
            border-bottom: 0.849px solid rgba(25, 25, 26, 0.15);
            background: transparent;
        }
        .mfn-policy a {
            color: rgb(0, 0, 0);
            text-decoration: underline;
        }
        .mfn-policy .mfn-policy-approve {
            display: block;
            margin-top: 5px;
        }
        .mfn-submit:hover {
            box-shadow: rgba(0, 0, 0, 1) 5px 5px 0px 0px;
        }
        .mfn-submit {
            position: absolute;
            width: 50px;
            height: 50px;
            right: 10px;
            opacity: 1;
            transition: opacity 0.5s;
            top: 90px;
            box-shadow: rgba(0, 0, 0, 0.1) 5px 5px 0px 0px;
            font-size: 20px;
            font-weight: 700;
            box-sizing: border-box;
            opacity: 1;
            transition: visibility 0s, opacity 0.5s linear;
        }
        .mfn-submit .mfn-sub-submit {
            font-size: 0;
            width: 100%;
            height: 100%;
            background: rgb(255, 214, 62);
            display: flex;
            -webkit-box-align: center;
            align-items: center;
            -webkit-box-pack: center;
            justify-content: center;
            outline: none;
            max-width: 300px;
            cursor: pointer;
            border: 1px solid rgb(0, 0, 0);
        }
        .mfn-submit .mfn-sub-submit:before {            
            content: url('data:image/svg+xml,<%3Fxml version="1.0" encoding="UTF-8"%3F><svg width="28px" height="18px" viewBox="0 0 28 18" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><!-- Generator: Sketch 64 (93537) - https://sketch.com --><desc>Created with Sketch.</desc><g id="Mobile" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linecap="round"><g id="Landing-Active" transform="translate(-321.000000, -111.000000)" stroke="%23000000" stroke-width="2"><g id="Input" transform="translate(20.000000, 86.000000)"><g id="Group-38" transform="translate(290.000000, 9.000000)"><g id="Group-3" transform="translate(12.000000, 17.000000)"><line x1="1.38555833e-13" y1="8" x2="25.1686508" y2="8" id="Path" fill="%23FFF9F2" fill-rule="nonzero"></line><polyline id="Path" points="17.3019841 16 25.1686508 8 17.3019841 0"></polyline></g></g></g></g></g></svg>');
        }
        .mfn-status {
            color: rgb(13, 13, 13);
            width: 100%;
            font-size: 24px;
            font-style: normal;
            font-weight: 700;
            line-height: 30px;
        }
        .mfn-block.mfn-alert-active {
            background-color: #db000047;
        }
        `}
      </style>
      <div id="subscribe-module" className={classes}></div>
    </>
  )
}
